import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Output,
	OnInit,
	Input,
} from '@angular/core';
import {
	ICmmsFilterComponent,
	ICmmsFilterEmittedValue,
} from '@app/pages/cmms/components/cmms-sort-filters-grouping/cmms-applied-filters-bar/interfaces/filter-component.interface';
import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';
import { CmmsFiltersService } from '@app/pages/cmms/components/cmms-sort-filters-grouping/services/cmms-filters.service';
import { of } from 'rxjs';

import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'ifc-filter',
	templateUrl: './ifc-filter.component.html',
	styleUrls: ['./ifc-filter.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgxTolgeeModule],
})
export class IfcFilterComponent implements ICmmsFilterComponent, OnInit {
	@Output() filterValueChanged = new EventEmitter<ICmmsFilterEmittedValue>();

	statuses: { key: string; value: boolean }[] = [
		{ key: 'show', value: true },
		{ key: 'hide', value: false },
	];

	selectedStatus: boolean;
	@Input() data: {
		activePage: CmmsPages;
		columnName: string;
		preselectedValue: boolean;
	} = null;

	constructor(private filterService: CmmsFiltersService) {}

	ngOnInit() {
		if (this.data.preselectedValue !== undefined) {
			const status = this.statuses.find(
				status => status.value === this.data.preselectedValue
			);

			this.selectStatus(status);
		}
	}

	selectStatus(event: { key: string; value: boolean }) {
		this.selectedStatus = event.value;
		this.filterValueChanged.emit({
			columnName: this.data.columnName,
			label: event.key,
			data: event.value,
		});
	}

	getDefaultFilterValue() {
		const filterValue = this.filterService.defaultFilterValues.get(this.data.columnName);
		let value = null;
		if (filterValue !== undefined) {
			const defaultStatus = this.statuses.find(status => status.value === filterValue);
			value = { label: defaultStatus.key, data: defaultStatus.value };
		}
		return of(value);
	}
}
